<template>
  <div class="empty-state flex flex-col items-center justify-center py-16 px-4">
    <div class="empty-icon mb-6">
      <i :class="iconClass" class="text-6xl text-gray-300"></i>
    </div>
    <h3 class="text-xl font-bold text-gray-700 mb-2">{{ title }}</h3>
    <p class="text-gray-500 text-center max-w-md mb-6">{{ message }}</p>
    <button
      v-if="showAction"
      @click="$emit('action')"
      class="action-btn bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-700 hover:to-blue-700 text-white px-6 py-3 rounded-xl font-semibold transition-all transform hover:-translate-y-1 hover:shadow-lg"
    >
      <i :class="actionIcon" class="mr-2"></i>
      {{ actionText }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    title: {
      type: String,
      default: 'No Data Available'
    },
    message: {
      type: String,
      default: 'There is no leaderboard data to display at this time.'
    },
    icon: {
      type: String,
      default: 'fas fa-trophy'
    },
    showAction: {
      type: Boolean,
      default: false
    },
    actionText: {
      type: String,
      default: 'Take a Quiz'
    },
    actionIcon: {
      type: String,
      default: 'fas fa-play'
    }
  },
  computed: {
    iconClass() {
      return this.icon
    }
  },
  emits: ['action']
}
</script>

<style scoped>
.empty-icon {
  animation: float 3s ease-in-out infinite;
}

@keyframes float {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.action-btn {
  box-shadow: 0 4px 14px 0 rgba(102, 126, 234, 0.39);
}
</style>
